import HousingCompanyLayout from "components/housingCompany/HousingCompanyLayout";


function HousingCompanyPage() {

    return (
        <HousingCompanyLayout/>
    );
}

export default HousingCompanyPage;